"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var React = __importStar(require("react"));
function UndrawCandidate(p) {
  var primaryColor = p.primaryColor,
    height = p.height,
    style = p.style,
    props = __rest(p, ["primaryColor", "height", "style"]);
  var styleProps = __assign({
    width: '100%',
    height: height
  }, style);
  return React.createElement("svg", __assign({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 938 604",
    style: styleProps
  }, props), React.createElement("path", {
    d: "M680.584 566.656l-4.873-60.576-13.926 64.057s.184 16.16.645 33.863h17.84c.602-20.236.314-37.344.314-37.344zM429.99 588.199a123.334 123.334 0 01-2.898-17.221l-1.95-20.955c-.819-5.739-1.661-10.795-2.508-15.258-6.208-31.823-12.616-32.974-12.616-32.974-.275.211-.543.445-.819.685a20.629 20.629 0 00-2.098 2.214c-10.206 12.973-17.13 46.619-20.768 68.939-2.009 12.33-3.01 21.201-3.01 21.201s.91 3.78 2.15 9.17h46.575a82.799 82.799 0 00-2.059-15.801z",
    fill: "#f2f2f2"
  }), React.createElement("path", {
    d: "M796.22 0H141.78C63.8 0 0 63.8 0 141.78v320.44C0 540.2 63.8 604 141.78 604h207.422l-2.677-12.601s-6.884-44.428 0-79.066a260.03 260.03 0 004.567-32.928 198.378 198.378 0 016.097-36.973c.182-.699.386-1.391.576-2.088-1.679-.456-2.45-.821-2.06-1.052 1.076-.635 1.667-2.58 1.962-5.05a241.718 241.718 0 0110.437-48.095c-6.957 4.368-11.575 4.831-14.6 3.14-10.625-2.903-6.214-26.8-6.214-26.8s6.604-51.69 8.797-70.407c1.261-10.758 17.42-16.854 31.724-20.164 1.507-3.233 2.592-6.49 1.903-9.907-.046-.23-.113-.453-.174-.678-1.819-4.04-5.516-7.363-6.903-11.546a12.182 12.182 0 01-1.283-3.603c-1.23-7.172 5.477-13.368 7.41-20.266a16.695 16.695 0 01-4.287-6.876c-2.947-6.043-1.51-13.297 7.952-18.898 1.889-1.118 3.89-2.105 5.924-3.051a9.214 9.214 0 012.405-1.103c6.77-3.063 13.575-6.026 17.627-11.988 1.043-1.536 1.958-3.317 3.646-4.124a7.035 7.035 0 012.512-.562c13.045-1.002 24.857 10.185 37.84 8.582 3.934-.486 7.949-2.14 11.724-.95 2.48.783 4.416 2.688 6.084 4.659a48.005 48.005 0 0110.41 39.529c-1.646 8.553-5.65 17.368-2.765 25.597 2.12 6.047 7.795 10.954 7.835 17.35.033 5.263-3.703 9.463-7.312 13.558q.704.72 1.372 1.48c8.82 10.05 7.154 18.627 5.91 22.061v.002l-4.536 43.774-3.825 29.367s-.946 12.052-9.854 14.695c-2.596 1.2-5.995 1.517-10.464.157-2.9-.882-5.343-1.764-7.417-2.622 1.96 6.26 5.334 19.04 4.786 31.444-.765 17.32 1.53 18.825 1.53 18.825a3.101 3.101 0 01-.487.481c9.087 20.076 9.17 40.674-.278 61.265-10.71 23.343.765 77.56.765 77.56s.817 8.457 1.184 17.872h164.288c-2.613-24.923-5.752-49.873-7.147-52.662-2.299-4.598.62-80.345 1.71-106.656a46.257 46.257 0 01-1.403-.375 30.324 30.324 0 01-2.12-.693 15.453 15.453 0 00.42 3.98c.968 2.256-1.351 3.914-5.292 5.046 2.292 11.186 5.123 32-4.455 36.033-9.853 4.149-10.05-21.051-9.509-34.187-1.243.046-2.489.07-3.72.07-11.837 0 3.481-137.165 2.785-146.217-.696-9.051 5.57-45.954 5.57-45.954s2.089-7.659 8.355-9.051 36.206-18.8 36.206-18.8a22.362 22.362 0 016.267-5.932v-1.03a22.965 22.965 0 012.485-2.012c-.365-6.083-1.188-13.932-1.788-19.235a24.302 24.302 0 01-6.533-12.5 38.369 38.369 0 01-3.646-3.239 18.996 18.996 0 01-4.67-11.856 37.464 37.464 0 011.857-12.8 15.324 15.324 0 011.613-3.908 14.145 14.145 0 013.645-3.614c.423-.313.86-.607 1.295-.903a12.194 12.194 0 013.94-4.471c3.553-2.334 8.126-2.143 12.376-2.037l.192.001q1.183-.19 2.374-.314a2.434 2.434 0 001.903-1.865l1.726 1.658q1.295-.019 2.588.044A18.49 18.49 0 01679.7 148l.946 2.698c.866.092 1.729.209 2.587.358l2.03-1.614c.15-.119.69 1.643.961 2.248.466.12.93.247 1.39.39.72-.033 1.52-.168 1.963-.16a13.13 13.13 0 016.997 1.744 15.027 15.027 0 014.448 5.133 33.252 33.252 0 014.964 14.321 16.6 16.6 0 012.754 6.155c1.15 6.99-5.493 12.83-6.81 19.79-.701 3.713.1 7.826-1.791 11.097a11.588 11.588 0 01-3.19 3.344 24.067 24.067 0 01-2.357 1.553 60.516 60.516 0 001.441 12.515l.896 3.435a87.432 87.432 0 014.544 3.527s19.496 8.356 26.459 12.533c6.12 3.673 12.776 4.121 14.77 8.905l.548.147s6.962 77.286 7.659 90.515 9.051 94.693 7.659 98.174c-.516 1.289-3.8 2.767-7.764 3.943 2.314 10.575 6.05 33.572-4.073 37.834-10.261 4.32-10.05-23.193-9.438-35.757-1.369-.123-2.266-.481-2.398-1.146-.114-.565-.477-3.122-1.001-7.02-.868.135-1.767.274-2.725.42l-.59.088c8.828 27.768-10.723 101.412-14.484 115.827-1.965 7.532-4.084 26.157-5.995 45.003h86.121C874.2 604 938 540.2 938 462.22V141.78C938 63.8 874.2 0 796.22 0z",
    fill: "#f2f2f2"
  }), React.createElement("ellipse", {
    cx: 210,
    cy: 169,
    rx: 95,
    ry: 86.45,
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M366.5 451.5s32-22 32-32 22-75 34-46-17 70-17 70-32 58-51 68-35 4-35 4v-27l18.282-27.057A22.59 22.59 0 01366.5 451.5z",
    fill: "#ffb9b9"
  }), React.createElement("path", {
    d: "M275.544 298.336S323.5 313.5 328.5 320.5s7-5 21 41S367 452 367 452s-34.5 11.5-30.5 56.5-6 94-6 94h-12.484l-27.516-85 33-129s-46.913-79.327-47.956-90.164z",
    fill: "#575a89"
  }), React.createElement("circle", {
    cx: 259.5,
    cy: 196.5,
    r: 60,
    fill: "#ffb9b9"
  }), React.createElement("path", {
    d: "M282.5 241.5s-17 56-2 64 32 44 32 44l-26 29h-60l-27-30-11-51 15-12s16-40 16-61 63 17 63 17z",
    fill: "#ffb9b9"
  }), React.createElement("path", {
    d: "M287.5 303.5s-12-3-5 9 14 34-11 35-50-12-58-39-11-25-14-24-35 34-35 34l11 62 4 222h146s6-64-4-79 9-53 9-53 17-26 4-76-42-91-47-91z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M206.5 284.5s-15-7-28 5-42 22-42 28 25 177 8 207-35 78-35 78h83.413s13.587-50 27.587-77 13-103 9-126-23-115-23-115z",
    fill: "#575a89"
  }), React.createElement("path", {
    fill: "#ffb9b9",
    d: "M118.5 549.5l4.87 53h54.047l-4.917-66-54 13z"
  }), React.createElement("path", {
    fill: "#3f3d56",
    d: "M364.5 521.5l13 81h289l25-163-327 82z"
  }), React.createElement("path", {
    fill: "#3f3d56",
    d: "M702.5 428.5l3 15-374 90v-13l371-92z"
  }), React.createElement("path", {
    fill: "#3f3d56",
    d: "M544.5 455.5l-2 17 22-3-9-17-11 3z"
  }), React.createElement("path", {
    d: "M423.5 283.5s44-3 56 31 40 95 51 104 23 33 21 41",
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), React.createElement("path", {
    d: "M430 283c0 4.694-4.992 8.5-13 8.5s-12-3.806-12-8.5 3.992-8.5 12-8.5 13 3.806 13 8.5z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M356 439s7.5-31.5-6.5-77.5-16-34-21-41-52.956-22.164-52.956-22.164c.343 3.561 5.638 14.517 12.595 27.624a53.193 53.193 0 00-5.639-13.46c-7-12 5-9 5-9 5 0 34 41 47 91s-4 76-4 76z",
    fill: "#575a89"
  }), React.createElement("path", {
    d: "M276 298s5.92 22.458 10.96 25.729 34.93 34.325 34.93 34.325L318 333l-16-24-4.256-3.088z",
    fill: "#575a89"
  }), React.createElement("path", {
    d: "M143 367l1.394-51.5s-32.894 14-35.894 74 5 173 16 174 63-11 63-11 8-145 5-164S143 367 143 367z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M145.5 315.5h-8.106s-32.894 14-35.894 74 5 173 16 174 63-11 63-11 8-145 5-164-40-73-40-73z",
    fill: "#575a89"
  }), React.createElement("ellipse", {
    cx: 188,
    cy: 180.5,
    rx: 62,
    ry: 69.5,
    fill: "#3f3d56"
  }), React.createElement("ellipse", {
    cx: 232.5,
    cy: 218.5,
    rx: 12.5,
    ry: 18.5,
    fill: "#ffb9b9"
  }), React.createElement("circle", {
    cx: 126,
    cy: 111,
    r: 51,
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M132.592 151.857a50.996 50.996 0 01-73.893-40.613 50.995 50.995 0 10101.176 2.838 50.921 50.921 0 01-27.283 37.775z",
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M98.02 119.43a50.996 50.996 0 0125.683-80.312 50.994 50.994 0 1016.625 99.84A50.921 50.921 0 0198.02 119.43z",
    fill: "#3f3d56"
  }), React.createElement("ellipse", {
    cx: 263,
    cy: 150,
    rx: 36,
    ry: 26,
    fill: "#3f3d56"
  }));
}
exports.default = UndrawCandidate;